import NetworkCall from "network/networkCall";
import Request from "network/request";

export class RecruiterGoals {
  static async getAll(params, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.getRecruiterGoals(params),
      useLoading,
      false,
    );
  }

  static async create(data, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.createRecruiterGoals(data),
      useLoading,
      false,
    );
  }

  static async update(recruiterGoalId, data, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.updateRecruiterGoals(recruiterGoalId, data),
      useLoading,
      false,
    );
  }

  static async delete(recruiterGoalId, useLoading = true) {
    return NetworkCall.fetch(
      Request.v2.deleteRecruiterGoals(recruiterGoalId),
      useLoading,
      false,
    );
  }
}
